<template>
  <div class="dashboard-container column">
    <LeaseInclusionModal v-model="showLeaseInclusion" />
    <InformationModal v-model="showInformationModal" @onClose="handleShowInfoModal(false)" />
    <div
      class="dashboard-header-container row"
      v-if="
        !isFetchRatebookLoading && !this.$apollo.queries.getSalesforceAccountByUser.loading && !this.$apollo.queries.getBusinessInfo.loading
      "
    >
      <div class="header-title-container">
        <h4 class="header-title">Welcome {{ firstName }}</h4>
        <p class="header-subtitle q-ma-md">
          In your account you can view your shortlisted vehicles, search for new ones, and apply for a credit limit.
        </p>
      </div>
    </div>
    <LoadingVehicle
      v-if="
        isFetchRatebookLoading || this.$apollo.queries.getSalesforceAccountByUser.loading || this.$apollo.queries.getBusinessInfo.loading
      "
    />
    <div v-else class="dashboard-body-container row">
      <div class="dashboard-body-action row">
        <div class="left-column">
          <CalculatorButton
            class="home-button q-mb-sm q-mr-sm self-end"
            color="primary"
            rounded
            label="Home"
            :icon="homeIcon"
            iconDirection="left"
            outlined
            removeOpacity
            @click="handleHome"
          />
        </div>
        <div class="right-column row">
          <div class="filter-action-desktop row">
            <LeaseTermOptions class="lease-term-options q-mb-sm q-mr-sm" v-model="leaseTerm" :options="leaseTermOptions" />
            <LeaseDistance class="lease-distance-field q-mb-sm q-mr-sm" v-model="leaseDistance" />
            <RepaymentOptions class="q-mb-sm q-mr-sm" v-model="repaymentOption" :isActive="!isArchived" />
          </div>
          <!-- <CalculatorButton
            class="self-end q-mb-sm"
            :color="showLeaseInclusion ? 'secondary' : undefined"
            rounded
            hasChevronIcon
            label="Lease inclusions"
            outlined
            removeOpacity
            @click="handleLeaseInclusionDialog"
          /> -->
        </div>

        <QSlideTransition>
          <div v-show="showFilterTransition" class="filter-action-transition full-width">
            <QCard v-if="showFilterContainer" class="filter-action-card column q-my-sm q-pa-sm full-width" flat bordered>
              <LeaseTermOptions class="q-mb-sm q-mr-sm" v-model="leaseTerm" :options="leaseTermOptions" />
              <LeaseDistance class="q-mb-sm q-mr-sm" v-model="leaseDistance" />
              <RepaymentOptions class="q-mb-sm q-mr-sm" v-model="repaymentOption" :isActive="!isArchived" />
            </QCard>
          </div>
        </QSlideTransition>
      </div>
      <div class="credit-app-progress-container col-12 col-md-grow">
        <ProgressStepsInActive v-if="isArchived" :activeSteps="activeStep" :steps="progressWizardSteps" />
        <ProgressSteps v-else :activeSteps="activeStep" :steps="progressWizardSteps" />
      </div>
      <div
        :class="['shortlists-container', 'col-12 col-md-grow', ...(!shortlist.length && !skipShortlistStep && ['no-vehicle'])].join(' ')"
      >
        <div class="col-12 col-md-grow" v-if="(isArchived && closedOpp_isClosedOpportunity) || (!shortlist.length && !skipShortlistStep)">
          <div class="q-px-lg q-py-sm">
            <MainHeadline
              v-if="isArchived && closedOpp_isClosedOpportunity"
              align="center"
              header="No vehicle application found"
              body="It
            looks like you don't have an active vehicle application in our system."
            />
            <MainHeadline
              v-else
              align="center"
              header="No vehicles are shortlisted."
              body="Please shortlist at least one vehicle to proceed."
            />
          </div>
          <div class="q-px-lg q-py-sm">
            <ContactUs />
          </div>
        </div>
        <template v-if="!showRequestCallback && !(isArchived && closedOpp_isClosedOpportunity)">
          <VehicleShortlistCard
            v-for="(shortlist, index) in formattedShortlist"
            :key="index"
            class="vehicle-shortlist-card"
            :imagePath="shortlist.jatoImagepath"
            :imagePathBase="shortlist.jatoImagepathBase"
            :imagePathTrim="shortlist.jatoImagepathTrim"
            :fuelType="`${shortlist.catalogYear} | ${shortlist.vehiclePrimaryfueltype} | ${shortlist.vehicleTransmissiongroup}`"
            :vehicleDescription="formatDescription(shortlist)"
            :vehicleName="`${formatWordsAsSentences(shortlist.vehicleMake)} ${formatWordsAsSentences(shortlist.vehicleModel)} ${
              shortlist.vehicleTrim || ''
            } |  ${shortlist.vehicleDrivetrain}`"
            :vehicleMake="shortlist.vehicleMake"
            :weeklyPrice="shortlist.weekLeaseprice"
            :monthlyPrice="shortlist.monthLeaseprice"
            :rrp="shortlist.consumerPrice"
            :repaymentOption="repaymentOption"
            :showPaymentBreakdown="false"
            @onRemoveShortlist="handleRemoveShortlist(shortlist)"
            @onViewVehicle="onViewVehicle(shortlist)"
            expanded
            displayRRPInfo
            @onInfoIconClick="handleShowInfoModal(true)"
            @onPricingInfoIconClick="showDisclaimerDialog"
          />
        </template>
        <RequestCallbackModal class="request-call-container" v-model="showRequestCallback" />
        <div class="shortlist-footer-container row q-mt-xl justify-between full-width">
          <CalculatorButton
            color="primary"
            rounded
            hasChevronIcon
            label="Search more vehicles"
            outline
            iconDirection="left"
            removeOpacity
            @click="handleEditShortlist"
          />
          <div>
            <CalculatorButton
              class="request-call-button q-mr-sm"
              color="primary"
              rounded
              :icon="phoneIcon"
              iconDirection="left"
              label="Request a call"
              outline
              removeOpacity
              @click="handleRequestCallbackDialog"
            />
            <CalculatorButton
              v-if="showCreditApplicationButton"
              color="primary"
              rounded
              hasChevronIcon
              :label="currentStatus !== null ? 'Continue credit application' : 'Start credit application'"
              :loading="isLoadingCreditApplication"
              :disabled="!shortlist.length && !skipShortlistStep"
              :outline="!shortlist.length && !skipShortlistStep"
              removeOpacity
              @click="handleCreditApplication"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeaseInclusionModal from '../../components/Calculator/LeaseInclusion/LeaseInclusionModal';
import InformationModal from '../../components/Calculator/Modal/InformationModal';
import RequestCallbackModal from '../../components/Calculator/RequestCallback/Modal';
import { QCard, QSlideTransition } from 'quasar';
import LeaseTermOptions from '../../components/Calculator/LeaseTermOptions';
import RepaymentOptions from '../../components/Calculator/RepaymentOptions';
import LeaseDistance from '../../components/Calculator/LeaseDistance';
import ProgressSteps from '../../components/Calculator/CreditApplication/ProgressSteps';
import { evaHomeOutline, evaOptions2, evaPhoneOutline, evaCloseCircleOutline } from '@quasar/extras/eva-icons';
import { CalculatorDialog } from '../../components/Calculator/CalculatorDialog';
import CalculatorButton from '../../components/Calculator/CalculatorButton';
import VehicleShortlistCard from '../../components/Calculator/ViewShortlist/VehicleShortlistCard';
import { debounce } from 'lodash';
import { fetchRatebookMixin, shortListOperationsMixin, closedOpportunityMixin, disclaimerDialogMixin } from '../../mixins/calculator';
import { formatWordsAsSentences } from '../../utils/calculator/wordFormatter';
import { DEFAULT_LEASE_TERM, LEASE_TERM_OPTIONS } from '../../utils/constants';
import { getLeaseTermByValue } from '../../utils/calculator/leaseTermUtils';
import MyCustomFunctions from '@/mixins/MyCustomFunctions.js';
import QueryGetSalesforceAccountByUser from '../../graphql/queries/QueryGetSalesforceAccountByUser';
import QueryBusinessLookup from '../../graphql/queries/QueryBusinessLookup';
import { mapGetters } from 'vuex';
import LoadingVehicle from '../../components/LoadingVehicle/LoadingVehicle';
import QueryGetSalesforceOpportunityByUser from '../../graphql/queries/QueryGetSalesforceOpportunityByUser';
import MutateUpdateQuoteStageName from '../../graphql/mutations/MutateUpdateQuoteStageName';
import {
  baseProgressActiveStepsFromStatus,
  mapActiveStepsWithoutShortlist,
  FULL_CREDIT_WIZARD_STEPS,
  COMPACT_CREDIT_WIZARD_STEPS
} from '../../utils/calculator/creditApplicationProgressWizard';
import {
  isScoreboardProductWithEmptyShortlists,
  isScoreboardProductApplicationType
} from '../../utils/calculator/scoreboardApplicationType';

export default {
  name: 'DashboardPage',
  mixins: [shortListOperationsMixin, fetchRatebookMixin, MyCustomFunctions, closedOpportunityMixin, disclaimerDialogMixin],
  apollo: {
    getSalesforceAccountByUser: {
      query: QueryGetSalesforceAccountByUser,
      debounce: 300,
      fetchPolicy: 'network-only'
    },
    getSalesforceOpportunityByUser: {
      query: QueryGetSalesforceOpportunityByUser,
      debounce: 300,
      fetchPolicy: 'network-only',
      skip() {
        return this.skipFetchOpportunity;
      },
      async result(response) {
        const opportunity = response?.data?.getSalesforceOpportunityByUser;

        this.isCalculatorManual = opportunity?.LeadSource === 'Calculator Manual';

        if (opportunity && opportunity?.StageName === 'Needs Analysis') {
          await this.updateQuoteStageName('Quote Requested OP');
        }

        // Closed Opportunity feature mixin, public entry
        if (this.isArchived) this.closedOpp_processOpportunity(opportunity);
      }
    },
    getBusinessInfo: {
      query: QueryBusinessLookup,
      debounce: 300,
      fetchPolicy: 'network-only',
      variables() {
        return {
          param: this.abn,
          region: this.region
        };
      }
    }
  },
  data() {
    return {
      firstName: '',
      showLeaseInclusion: false,
      showFilterTransition: true,
      showFilterContainer: false,
      showInformationModal: false,
      showRequestCallback: false,
      skipFetchOpportunity: true,
      isCalculatorManual: true,
      leaseTerm: {},
      defaultLeaseTerm: DEFAULT_LEASE_TERM,
      leaseTermOptions: LEASE_TERM_OPTIONS,
      leaseDistance: 15000,
      vehicleLeaseTerms: [],
      dashboardRatebook: [],
      repaymentOption: 'weekly',
      homeIcon: evaHomeOutline,
      filterIcon: evaOptions2,
      phoneIcon: evaPhoneOutline,
      isLoadingCreditApplication: false
    };
  },
  methods: {
    formatWordsAsSentences,
    handleLeaseInclusionDialog() {
      this.showLeaseInclusion = true;
    },
    async handleShowInfoModal(value) {
      if (value) {
        await new Promise((resolve) => {
          setTimeout(() => {
            this.showInformationModal = false;
            resolve();
          }, 10);
        });
      }

      this.showInformationModal = value;
    },
    async updateQuoteStageName(stageName) {
      await this.$apollo.mutate({
        mutation: MutateUpdateQuoteStageName,
        fetchPolicy: 'no-cache',
        variables: {
          applicationId: this.vehicleApplication.applicationId,
          stageName
        }
      });
    },
    async getVehicleLeaseTerm() {
      const response = await this.fetchRatebook({
        pair: undefined,
        vehicleMake: undefined,
        catalogVehicleId: this.vehicleApplication.calculator?.shortlists?.map(({ catalogVehicleId }) => catalogVehicleId) || [],
        pageSize: 100,
        minDuration: 36,
        maxDuration: 60
      });
      const ratebook = response?.results?.rows ?? [];
      const totalCount = response?.results?.totalCount ?? 0;

      this.dashboardRatebook = ratebook;

      const formattedLeaseTerms = ratebook
        .filter(({ duration }) => duration == this.leaseTerm?.value)
        .map((value) => {
          let leaseTerms = [];

          if (totalCount) {
            leaseTerms = ratebook
              .filter(({ catalogVehicleId }) => catalogVehicleId === value?.catalogVehicleId)
              .map(({ catalogPrice, consumerPrice, monthLeaseprice, weekLeaseprice, duration, durationUnit }) => ({
                catalogPrice,
                consumerPrice,
                monthLeaseprice,
                weekLeaseprice,
                duration,
                durationUnit
              }));
          }

          return {
            ...value,
            vehicleTrim: value?.vehicleTrim || '',
            leaseTerms
          };
        });

      this.vehicleLeaseTerms = formattedLeaseTerms;
      this.loadVehiceApplicationShortlist();
    },
    async handleRemoveShortlist(value) {
      const { applicationId } = this.vehicleApplication;
      const { id: userId } = this.user;

      this.shortlist = this.shortlist.filter((vehicle) => vehicle.catalogVehicleId !== value.catalogVehicleId);
      this.vehicleLeaseTerms = this.vehicleLeaseTerms.filter((vehicle) => vehicle.catalogVehicleId !== value.catalogVehicleId);

      await this.updateShortListDB(applicationId, userId);

      this.handleEmptyShortlistRedirection();
    },
    handleEditShortlist() {
      this.$router.push({ name: 'calculatorResults' });
    },
    onViewVehicle(vehicle) {
      this.$router.push({
        name: 'vehicleProduct',
        params: {
          catalogVehicleId: vehicle.catalogVehicleId,
          vehicleMake: vehicle.vehicleMake,
          vehicleModel: vehicle.vehicleModel,
          vehicleTrim: vehicle.vehicleTrim ? vehicle.vehicleTrim.toUpperCase() : undefined,
          vehicleDrivetrain: vehicle.vehicleDrivetrain ? vehicle.vehicleDrivetrain.toUpperCase() : undefined
        }
      });
    },
    handleHome() {
      if (isScoreboardProductApplicationType(this.vehicleApplication)) {
        this.$router.push({ name: 'applications', params: { applicationId: this.vehicleApplication.applicationId } });
      } else {
        this.$router.push({ name: 'dashboard' });
      }
    },
    async handleCreditApplication() {
      try {
        this.isLoadingCreditApplication = true;

        if (!this.currentStatus) {
          await Promise.all([this.updateVehicleApplication('viewShortlist', 'status'), this.updateQuoteStageName('Deal Mobilising')]);
        }
      } catch (error) {
        // eslint-disable-next-line
        console.log({ error });
      } finally {
        this.$router.push({ name: 'applications', params: { applicationId: this.vehicleApplication.applicationId } });
        this.isLoadingCreditApplication = false;
      }
    },
    handleRequestCallbackDialog() {
      this.showRequestCallback = true;
      this.$nextTick(() => {
        const requestModal = this.$refs.requestModal?.getBoundingClientRect();
        const header = document.querySelector('.q-header');
        if (!requestModal || !header) {
          return;
        }
        window.scrollBy(0, requestModal.top - header.offsetHeight);
      });
    },
    handleEmptyShortlistRedirection() {
      if (!this.shortlist.length) {
        this.$euiNotifications.emit({
          notification: CalculatorDialog,
          headerIcon: evaCloseCircleOutline,
          header: 'No vehicles are shortlisted.',
          body: 'Please shortlist at least one vehicle to proceed.',
          closeFooterLabel: 'Return to search results'
        });

        this.$router.push({ name: 'calculatorResults' });
      }
    },
    formatDescription(vehicle) {
      const removeDetails = ['vehicleMake', 'vehicleModel', 'vehicleTrim'];
      let { vehicleDescription } = vehicle;

      if (!vehicleDescription) {
        return '';
      }

      removeDetails.forEach((detail) => {
        if (vehicle[detail]) {
          vehicleDescription = vehicleDescription.replace(vehicle[detail], '');
          vehicleDescription = vehicleDescription.replace(vehicle[detail].toUpperCase(), '');
          vehicleDescription = vehicleDescription.replace(vehicle[detail].replace(' ', '').toUpperCase(), '');
          vehicleDescription = vehicleDescription.replace(vehicle[detail].toLowerCase(), '');
        }
      });

      return vehicleDescription;
    },
    loadVehicleAppDetails() {
      this.firstName = !this.user?.lastName || this.user?.lastName === ' ' ? this.user.firstName.split(' ')[0] : this.user.firstName;
    },
    loadVehiceApplicationShortlist() {
      // TODO: Update shortlist will be based of userProfile
      this.shortlist = this.vehicleLeaseTerms.map((vehicle) => ({ ...vehicle, isShortlisted: true }));
      this.updateShortList();
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user'
    }),
    region() {
      return this.vehicleApplication?.scoreboard?.currentUser?.region ? this.vehicleApplication?.scoreboard?.currentUser?.region : 'AU';
    },
    abn() {
      const {
        scoreboard: { companyDetails }
      } = this.vehicleApplication;

      return companyDetails?.abn ? companyDetails?.abn : companyDetails?.nzbn;
    },
    isArchived() {
      return (
        this.vehicleApplication?.scoreboard?.status?.toLowerCase()?.includes('archived') ||
        this.vehicleApplication?.scoreboard?.docusignStatus?.toLowerCase()?.includes('archived')
      );
    },
    isUserValidForCreditApp() {
      const NZ_ENTITY_TYPE = ['ULTD', 'LTD', 'Sole_Trader'];
      const AU_ENTITY_TYPE = ['IND', 'PRV', 'PUB'];
      const entityType = this.getBusinessInfo?.rows?.[0]?.entityType;

      const account = this.getSalesforceAccountByUser;

      const isEntityTypeValid =
        this.region == 'NZ' ? NZ_ENTITY_TYPE.some((code) => code == entityType) : AU_ENTITY_TYPE.some((code) => code == entityType);

      const accountAllowsCredit = account?.AccountSource == 'Calculator' || this.skipShortlistStep;

      const isValidforCredit =
        isEntityTypeValid && accountAllowsCredit && (!this.isCalculatorManual || account?.Credit_Total_Value__c == null);

      return isValidforCredit;
    },
    formattedShortlist() {
      return this.vehicleLeaseTerms.map((value) => {
        const leaseTerm = value.leaseTerms.find((leaseTerm) => this.leaseTerm.value === leaseTerm.duration);

        return {
          ...value,
          ...leaseTerm
        };
      });
    },
    isCreditApplicationDisabled() {
      return !this.shortlist.length;
    },
    callBackData() {
      return {
        firstName: this.user?.firstName,
        lastName: this.user?.lastName,
        contactNumber: this.user?.contactNumber,
        email: this.user?.email
      };
    },

    currentStatus() {
      const status = this.vehicleApplication?.scoreboard?.status;
      if (typeof status === 'string') {
        const normalizedStatus = status.trim();
        return normalizedStatus ? normalizedStatus : null;
      }
      return status || null;
    },
    hasApplicationShortlists() {
      return (this.vehicleApplication?.calculator?.shortlists?.length ?? 0) > 0;
    },
    skipShortlistStep() {
      const t = String(this.vehicleApplication?.applicationType || '').toLowerCase();
      return t !== 'calculator' || !this.hasApplicationShortlists;
    },
    progressWizardSteps() {
      if (!this.skipShortlistStep) {
        return FULL_CREDIT_WIZARD_STEPS;
      }
      return COMPACT_CREDIT_WIZARD_STEPS;
    },
    activeStep() {
      const baseSteps = this.baseProgressActiveSteps;
      if (!this.skipShortlistStep) {
        return baseSteps;
      }
      return mapActiveStepsWithoutShortlist(baseSteps);
    },
    baseProgressActiveSteps() {
      const hasCreditTotal = !!parseFloat(this.getSalesforceAccountByUser?.Credit_Total_Value__c || 0);
      return baseProgressActiveStepsFromStatus(this.currentStatus, hasCreditTotal);
    },
    showCreditApplicationButton() {
      if (!this.isUserValidForCreditApp || this.isArchived) {
        return false;
      }
      if (this.currentStatus !== null) {
        return true;
      }

      // While the opportunity query is in flight, `canSendApplication` is unknown; treating
      // it as allowed made the button render then disappear when the response was `false`.
      if (this.$apollo.queries.getSalesforceOpportunityByUser?.loading) {
        return false;
      }

      if (this.getSalesforceOpportunityByUser?.canSendApplication === false) {
        return false;
      }
      return true;
    }
  },
  watch: {
    showFilterTransition(value) {
      debounce(() => {
        this.showFilterContainer = value;
      }, 100);
    }
  },
  created() {
    this.leaseTerm = getLeaseTermByValue(this.leaseTermOptions, this.defaultLeaseTerm) || this.leaseTermOptions[0];
    this.loadVehicleAppDetails();
    this.getVehicleLeaseTerm();

    this.skipFetchOpportunity = false;

    if (isScoreboardProductWithEmptyShortlists(this.vehicleApplication)) {
      this.$router.replace({
        name: 'applications',
        params: { applicationId: this.vehicleApplication.applicationId }
      });
    }
  },
  components: {
    QCard,
    QSlideTransition,
    CalculatorButton,
    RepaymentOptions,
    LeaseTermOptions,
    LeaseDistance,
    LeaseInclusionModal,
    ProgressSteps,
    InformationModal,
    RequestCallbackModal,
    VehicleShortlistCard,
    LoadingVehicle,
    ContactUs: () => import('@/components/Atoms/ContactUs'),
    MainHeadline: () => import('@/components/Atoms/MainHeadline'),
    ProgressStepsInActive: () => import('@/components/Calculator/CreditApplication/ProgressStepsInActive')
  }
};
</script>

<style lang="sass">
.dashboard-container
  max-width: 1440px
  padding: 20px
  .dashboard-header-container
    justify-content: end
    .header-title-container
      max-width: calc(100% - 310px)
      text-align: center
      flex: 1
    .header-title
      color: $primary
      font-size: 32px
    .header-subtitle
      font-size: 16px
      font-weight: 700
      line-height: 19.5px

  .dashboard-body-container
    padding-top: 20px
    .dashboard-body-action
      width: 100%
      padding-bottom: 20px
      .left-column
        display: flex
        min-width: 310px
        max-width: 320px
        .home-button.q-btn.calculator-button
          min-width: 114px
          .q-btn__wrapper
            padding: 0 15px
            .q-btn__content
              padding: 0
              display: flex
              flex-flow: row wrap
              justify-content: space-between
              align-items: center
              .q-icon
                padding-right: 10px
                font-size: 24px
      .right-column
        max-width: calc(100% - 310px)
        padding-left: 20px
        display: flex
        flex-flow: row wrap
        justify-content: space-between
    .shortlists-container
      max-width: calc(100% - 310px)
      padding-left: 20px
      .vehicle-shortlist-card
        margin: 0 0 20px 0
      .shortlist-footer-container
        .request-call-button.q-btn.calculator-button
          min-width: 168px
          .q-btn__wrapper
            padding: 0 15px
            .q-btn__content
              padding: 0
              display: flex
              flex-flow: row wrap
              justify-content: space-between
              align-items: center
              .q-icon
                padding-right: 10px
                font-size: 24px
      &.no-vehicle
        display: flex
        flex-flow: row wrap
        min-height: 400px
        .shortlist-footer-container
          align-self: end
    .credit-app-progress-container
      max-width: 310px
      max-height: 350px
      width: 100%
  .request-call-container
    align-self: end

  @media (max-width: 1280px)
    .dashboard-header-container .header-title-container
      max-width: 100%
    .dashboard-body-container
      max-width: 100%
      width: 100%

      .dashboard-body-action
        .left-column
          flex: 0
          min-width: auto
        .right-column
          justify-content: end
          max-width: 100%
          flex: 1
          .lease-distance-field
            flex: 1 150px
      .credit-app-progress-container
        max-width: 100%
        margin-bottom: 10px
        .progress-steps-container
          max-width: 100%
          .step-container
            padding: 10px 0
            .step-number
              height: 28px
              width: 28px
              font-size: 14px
            .step-label
              max-width: 100%
              span.new-line
                display: inline-block

      .shortlists-container
        background:black
        max-width: 100%
        padding-left: 0

@media (max-width: 425px)
  .q-dialog__inner.q-dialog__inner--minimized
    padding: 10px!important
</style>
